import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import QLogo from "@/components/QLogo";
import { SignOut, ShieldCheck, Sparkle, Wrench } from "@phosphor-icons/react";

export default function Account() {
  const nav = useNavigate();
  const { user, logout, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/profile", { name, email });
      setUser(data);
      toast.success("Profile updated");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Update failed");
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen pb-32" data-testid="account-page">
      <header className="px-6 pb-2 qd-pt-safe-header-lg"><QLogo size={32} /></header>
      <div className="px-6 pt-6 max-w-2xl mx-auto">
        <div className="qd-overline mb-2">Profile</div>
        <h1 className="qd-h1 text-3xl text-white mb-8">Account</h1>

        <div className="qd-card p-6 mb-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#FF1E1E] to-[#B30000] flex items-center justify-center font-display font-bold text-xl text-white">
              {(user?.name || user?.phone || "?")[0]}
            </div>
            <div>
              <div className="font-display text-white text-lg">{user?.phone}</div>
              <div className="text-[11px] font-mono-data tracking-widest text-white/40 uppercase">{user?.role}</div>
            </div>
          </div>

          <div className="mb-5">
            <label className="qd-label">Name</label>
            <input data-testid="account-name" className="qd-input-block" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" />
          </div>
          <div className="mb-5">
            <label className="qd-label">Email</label>
            <input data-testid="account-email" className="qd-input-block" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
          </div>
          <button data-testid="account-save" className="btn-primary w-full" onClick={save} disabled={saving}>{saving ? "Saving…" : "Save Changes"}</button>
        </div>

        <div className="space-y-2 mb-6">
          {user?.role === "admin" && (
            <button data-testid="open-admin" className="qd-card w-full p-4 flex items-center justify-between hover:border-[#FF1E1E]/40" onClick={() => nav("/admin")}>
              <span className="flex items-center gap-3 text-white"><Wrench size={18} weight="fill" className="text-[#FF1E1E]" /> Open Admin Command Center</span>
            </button>
          )}
          <div className="qd-card w-full p-4 flex items-center gap-3 text-white/70">
            <ShieldCheck size={18} className="text-[#FF1E1E]" weight="fill" />
            <span className="text-sm">Secured by 256-bit encryption · Phone-only login</span>
          </div>
        </div>

        <button data-testid="logout-btn" className="btn-secondary w-full flex items-center justify-center gap-2" onClick={() => { logout(); nav("/login"); }}>
          <SignOut size={16} /> Sign Out
        </button>
      </div>
    </div>
  );
}
